<template>
	<div class="nav py-1">
		<img src="../assets/svgs/aji_name.svg" alt="Logo" class="logo">
		<div class="d-flex align-items-center menu-con" @click="showMenu">
			<p class="mb-0 mr-5 black-text">MENU</p>
				<div class="d-flex flex-column py-4 ml-2 menuBar" ref="menuBar">
				<span class="bar one" ref="one"></span>
				<span class="bar two" ref="two"></span>
		</div>
		<!-- <Close></Close> -->
		</div>
	</div>
</template>

<script>
// import Close from '../components/CloseX'
export default {
	components:{
		// Close
	},
	methods:{
	showMenu(){
		let home = document.querySelector('.full-home');
		let menu = document.querySelector('.menu');
		let link = document.querySelectorAll('.menu-link-item');
		let body = document.querySelector('body');
		let menuBar = document.querySelector(".menuBar");
		let menuBarX = document.querySelector(".menuBarX");
			// 	this.$refs.menuBar.classList.remove("b-con");
			// this.$refs.menuBar.classList.add("rb-con");
				menuBar.classList.add("rb-con");
			menuBar.classList.remove("b-con");
			menuBarX.classList.add("rb-con");
			menuBarX.classList.remove("b-con");
			this.$store.commit("changeMenuState");
			home.classList.remove('show-display');
			home.classList.add('hide-display');
			menu.classList.add('show-display',"slide-in");
			menu.classList.remove('hide-display', 'slide-out');
			for(let i=0; i<link.length; i++){
				link[i].classList.add('text-slide');
			}
			body.style.height = "100vh";

		
		}
	}
}
</script>

<style scoped>
.menu-con:hover p{
	color:#8d140e;
	transition: all 0.3s ease-in;
	cursor: default;
}
.menu-con:hover .bar{
	background-color: #8d140e;
	transition: all 0.3s ease-in;
	border-color: #8d140e;
}
/*  */
	.one{
	margin-bottom: 3px;
}
.menuBar .bar{
	transition: all 0.2s ease-in;
}
/* .menuBar:hover{
		margin-top:20px;
		transition: all 0.8s ease-in;
} */
.menuBar:hover .bar{
	background-color: #8d140e;
	transition: all 0.3s ease-in;
	border-color: #8d140e;
}
.menuBar:hover .one{
	margin-bottom: 4px;
	transition: all 0.3s linear;
}
.menuBar:hover .two{
	margin-top: 4px;
	transition: all 0.3s linear;
}
.bar{
	background-color:#13120d;
	height:2px;
	width:40px;
	display: inline-block;
}
.rb-con .one{
	margin-bottom:0px;
	transform: rotate(45deg);
	transition: all 0.4s ease-in-out;
	background-color:#8d140e;
}
.rb-con .two{
	transform: rotate(-45deg);
	transition: transform 0.4s ease-in-out;
	background-color:#8d140e;
}
.b-con .one, .b-con .two{
	transform: rotate(0deg);
	transition: transform 0.4s ease-in-out;
}
/*  */
.nav{
	display:flex;
	justify-content: space-between;
	align-items: center;
	background-color:rgba(239, 238, 235, 1);

}
.logo{
	width:90px;	
}
.menuBar{
	position: fixed;
	right:55px;
	z-index: 5;
}
@media only screen  and (max-width:767px){
	.menuBar{
		right:15px;
		position: fixed;

	}
}

</style>